import { DistributorActions } from "../actions";

const initialState = {
  distributors: [],
  distributor: null,
};

export default function distributor(state = initialState, action) {
  switch (action.type) {
    case DistributorActions.ACTION_SAVE_DISTRIBUTORS:
      return {
        ...state,
        distributors: action.payload,
      };
    case DistributorActions.ACTION_SAVE_DISTRIBUTOR:
      return {
        ...state,
        distributor: action.payload,
      };
    default:
      return state;
  }
}

export function getDistributors(state) {
  return state.distributor.distributors;
}
export function getDistributor(state) {
  return state.distributor.distributor;
}
